module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_05_770_280_ja-27ed863859be829e2d5098b0d720c872.jpg";